module.exports = __webpack_public_path__ + "img/Zeppa_e_Intersuola_DX.f722d7c6.png";